import classNames from "classnames";
import { CSSProperties } from "react";
import "./Bar.scss";

const Bar = ({
	label,
	style,
	className,
	...props
}: {
	label: string;
	style: CSSProperties;
	className?: string;
}) => {
	return (
		<div
			className={classNames("bar", className)}
			data-value={label}
			style={style}
			{...props}
		/>
	);
};

export default Bar;
